import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UserActions } from '../../../../core/stores/user/user.actions';
import { RootState } from '../../../../core/stores/store';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable, take } from 'rxjs';
import { forkJoin, map } from 'rxjs';
import { selectSidebarCollapsedState } from '../../../../core/stores/app/app.selectors';
import { AppActions } from '../../../../core/stores/app/app.actions';
import { PermissionService } from '../../../../core/local-services/permission.service';
import { User } from '../../../../shared/interfaces/user.interfaces';
import { selectCurrentUser } from '../../../../core/stores/user/user.selectors';

@Component({
  selector: 'app-sidebar',
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    TranslateModule,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  @ViewChild(MatSidenav)
  sidenav!: MatSidenav;

  isCollapsed$: Observable<boolean | undefined>;

  user$: Observable<User | undefined>;
  userId: number | null = null;
  userDealerId: number | null = null;

  constructor(
    private store: Store<RootState>,
    private translateService: TranslateService,
    public permissionService: PermissionService,
  ) {
    this.translateService.setDefaultLang('en');
    this.translateService.use(this.translateService.getBrowserLang() || 'en');
    this.isCollapsed$ = this.store.select(selectSidebarCollapsedState);
    this.user$ = this.store.select(selectCurrentUser);
  }

  ngOnInit(): void {
    this.user$.pipe(take(1)).subscribe((user) => {
      if (user) {
        this.userId = user.id;
        this.userDealerId = user.dealer.id;
      }
    });
  }

  toggleMenu(): void {
    this.isCollapsed$.pipe(take(1)).subscribe((state) => {
      this.store.dispatch(AppActions.setSidebar({ collapsed: !state }));
    });
  }

  // ...existing code...

  logout(): void {
    this.store.dispatch(UserActions.unsetUser());
  }

  hasAnyAdvancedReadPermission(): Observable<boolean> {
    const permissions = [
      'readEventDefinitions',
      'readEventProtocols',
      'readClickCommands',
      'readClickTemplates',
      'updateDealerSkin',
      'listApiKeys',
      'listWebhooks',
      'readForwarders',
      'readEquipmentConfig',
      'listEquipments',
    ];
    if (permissions.length === 0) {
      return new Observable<boolean>((observer) => {
        observer.next(false);
        observer.complete();
      });
    }
    return forkJoin(
      permissions.map((permission) =>
        this.permissionService.isAllowed(permission),
      ),
    ).pipe(map((results: boolean[]) => results.some(Boolean)));
  }
}
